<template>
  <transition name="modal" @click="$emit('close')">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container max-width">
          <div class="modal-header">
            <p class="text-circe-bold-20 color-green">Задать вопрос</p>
            <div class="modal-header__cross" @click="$emit('close')">
              <img src="../../assets/svg/CrossModal.svg" alt="cross" />
            </div>
          </div>
          <div class="error">
            <AppValidationErrors
                v-if="validationErrorsModal"
                :validation-errors="validationErrorsModal"
            />
          </div>
          <div class="error" v-if="isSubmitted && this.$v.$invalid">
            <p class="error-text">*Заполните все пустые поля</p>
          </div>
          <div class="modal-body">
            <!-- Поля формы -->
            <div class="modal-body__wrap-input">
              <label for="fullName" class="label-for-input">ФИО</label>
              <input
                  type="text"
                  name="fullName"
                  v-model="fullName"
                  placeholder="Введите ФИО"
                  class="input-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.fullName.$error,
                }"
              />
            </div>
            <div class="modal-body__wrap-input">
              <label for="phone" class="label-for-input">Телефон</label>
              <input
                  type="text"
                  name="phone"
                  placeholder="Введите телефон"
                  v-model="phone"
                  maxlength="16"
                  @input="onPhoneInput"
                  class="input-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.phone.$error,
                }"
              />
            </div>

            <div class="modal-body__wrap-input">
              <label for="address" class="label-for-input">Улица, номер дома, квартиры</label>
              <input
                  type="text"
                  name="address"
                  v-model="address"
                  placeholder="Введите адрес"
                  class="input-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.address.$error,
                }"
              />
            </div>
            <div class="modal-body__wrap-input">
              <label for="city" class="label-for-input">Населенный пункт</label>
              <input
                  type="text"
                  name="city"
                  v-model="city"
                  placeholder="Введите населенный пункт"
                  class="input-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.city.$error,
                }"
              />
            </div>
            <div class="modal-body__wrap-input">
              <label for="email" class="label-for-input">E-mail</label>
              <input
                  type="email"
                  name="email"
                  v-model="email"
                  placeholder="Введите e-mail"
                  class="input-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.email.$error,
                }"
              />
            </div>
            <div class="modal-body__wrap-input-column">
              <label for="subject" class="label-for-input">Тема обращения</label>
              <input
                  type="text"
                  name="subject"
                  v-model="subject"
                  placeholder="Введите тему обращения"
                  class="input-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.subject.$error,
                }"
              />
            </div>
            <div class="modal-body__wrap-input-column">
              <label for="message" class="label-for-input">Текст обращения</label>
              <textarea
                  name="message"
                  ref="messageTextarea"
                  v-model="message"
                  rows="3"
                  @input="onMessageInput"
                  placeholder="Введите текст обращения"
                  class="textarea-text"
                  :class="{
                  'error-border-input': isSubmitted && $v.message.$error,
                }"
              ></textarea>
            </div>
            <div class="modal-body__wrap-input-column">
              <label for="file-upload" class="label-for-input">Загрузка файлов <span class="color-gray text-circe-12"  v-if="fileLimit">ТОЛЬКО ИЗОБРАЖЕНИЯ(JPG,PNG), НЕ БОЛЕЕ: 2</span></label>
              <div class="error" v-if="fileAttachmentError">
                <p class="error-text">{{ fileAttachmentError }}</p>
              </div>
              <div class="custom-file-input">
                <label
                  for="file-upload"
                  class="custom-file-label"
                  :class="{ 'error-border-input': fileAttachmentError }"
                >
                  {{ displayFileNames }}
                </label>
                <input
                    type="file"
                    id="file-upload"
                    name="file"
                    @change="onFileChange"
                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                    multiple
                    class="input-file-hidden"
                />

              </div>

              <!-- Отображение миниатюр загруженных изображений -->
              <div v-if="filePreviews.some(Boolean)" class="file-previews">
                <div v-for="(preview, index) in filePreviews" :key="index" class="file-preview">
                  <img v-if="preview" :src="preview" alt="preview" class="file-preview-image" />
                </div>
              </div>
            </div>
            <!-- Согласие на обработку персональных данных -->
            <div class="modal-body__wrap-input-column">
              <div class="" v-if=" isSubmitted && $v.consent.$error">
                <p class="error-text">*Нет согласия на обработку персональных данных</p>
              </div>
              <label class="label-for-input">
                <input
                    type="checkbox"
                    v-model="consent"
                    :class="{
                    'error-border-input': isSubmitted && $v.consent.$error,
                  }"
                />
                Я даю свое согласие на обработку персональных данных
              </label>
            </div>
          <div class="">
            <p class="color-gray text-circe-14">
              С
              <router-link to="/about/privacy-policy" class="color-green text-circe-14" style="text-decoration: underline;">политикой обработки персональных данных</router-link>
              и
              <router-link to="/appeal/consent" class="color-green text-circe-14" style="text-decoration: underline;">согласием на обработку персональных данных</router-link>
              можно ознакомиться по ссылкам.
            </p>
          </div>
            <!-- Поле загрузки файла -->

          </div>

          <div class="modal-footer">
            <div class="modal-footer__btn">
              <button
                  type="button"
                  class="index-btn lite-color"
                  @click="$emit('close')"
              >
                Отменить
              </button>
            </div>
            <div class="modal-footer__btn">
              <button
                  type="button"
                  class="index-btn index-color"
                  @click="onSubmitForm"
              >
                Отправить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { required, email, sameAs, helpers } from "vuelidate/lib/validators";
  import { actionTypesAppeal } from '@/store/modules/modal'
  import { mapState } from 'vuex'
  import AppValidationErrors from '@/components/ValidationErrors.vue'

  const phoneFormat = helpers.regex("phoneFormat", /^\+7 \d{3} \d{3} \d{2} \d{2}$/);

  export default {
    name: "AppModalAskQuestion",
    components: { AppValidationErrors },
    data() {
      return {
        fullName: "",
        phone: "",
        address: "",
        city: "",
        email: "",
        subject: "",
        message: "",
        consent: false,
        attachedFiles: [],
        filePreviews: [],
        fileLimit: 2,
        fileAttachmentError: "",
        isSubmitted: false,
      };
    },
    computed: {
      displayFileNames() {
        return this.attachedFiles.length
          ? this.attachmentLabels.join(", ")
          : "Выберите файлы";
      },
      attachmentLabels() {
        return this.attachedFiles.map((f) => f.name);
      },
      ...mapState({
        validationErrorsModal: (state) => state.modal.validationErrorsModal,
      }),
    },
    validations: {
      fullName: { required },
      phone: { required, phoneFormat },
      address: { required },
      city: { required },
      email: { required, email },
      subject: { required },
      message: { required },
      consent: { required, sameAsConsent: sameAs(() => true) }
    },
    methods: {
      isAllowedImageFile(file) {
        const allowedTypes = ["image/jpeg", "image/png"];
        if (allowedTypes.includes(file.type)) {
          return true;
        }
        const name = (file.name || "").toLowerCase();
        return /\.(jpe?g|png)$/.test(name);
      },
      onFileChange(event) {
        const input = event.target;
        const files = Array.from(input.files || []);
        this.fileAttachmentError = "";

        if (files.length === 0) {
          this.attachedFiles = [];
          this.filePreviews = [];
          return;
        }

        if (files.length > this.fileLimit) {
          this.fileAttachmentError = `Можно прикрепить не более ${this.fileLimit} файлов.`;
          this.attachedFiles = [];
          this.filePreviews = [];
          input.value = "";
          return;
        }

        const invalidType = files.some((f) => !this.isAllowedImageFile(f));
        if (invalidType) {
          this.fileAttachmentError =
            "Разрешены только изображения в формате JPG или PNG.";
          this.attachedFiles = [];
          this.filePreviews = [];
          input.value = "";
          return;
        }

        this.attachedFiles = files;
        this.filePreviews = new Array(files.length);
        files.forEach((file, idx) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.$set(this.filePreviews, idx, e.target.result);
          };
          reader.readAsDataURL(file);
        });
      },
      onPhoneInput(event) {
        const rawValue = event.target.value || "";
        let digits = rawValue.replace(/\D/g, "");

        if (!digits) {
          this.phone = "";
          return;
        }

        if (digits[0] === "8") {
          digits = `7${digits.slice(1)}`;
        } else if (digits[0] !== "7") {
          digits = `7${digits}`;
        }

        const localDigits = digits.slice(1, 11);
        let formattedPhone = "+7";

        if (localDigits.length > 0) {
          formattedPhone += ` ${localDigits.slice(0, 3)}`;
        }
        if (localDigits.length > 3) {
          formattedPhone += ` ${localDigits.slice(3, 6)}`;
        }
        if (localDigits.length > 6) {
          formattedPhone += ` ${localDigits.slice(6, 8)}`;
        }
        if (localDigits.length > 8) {
          formattedPhone += ` ${localDigits.slice(8, 10)}`;
        }

        this.phone = formattedPhone;
      },
      onMessageInput() {
        this.$nextTick(() => {
          this.resizeMessageTextarea();
        });
      },
      resizeMessageTextarea() {
        const textarea = this.$refs.messageTextarea;
        if (!textarea) {
          return;
        }
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      },
      onSubmitForm() {
        this.isSubmitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if (this.attachedFiles.length > this.fileLimit) {
          this.fileAttachmentError = `Можно прикрепить не более ${this.fileLimit} файлов.`;
          return;
        }
        if (this.attachedFiles.some((f) => !this.isAllowedImageFile(f))) {
          this.fileAttachmentError =
            "Разрешены только изображения в формате JPG или PNG.";
          return;
        }
        if (
          this.attachedFiles.length &&
          this.filePreviews.filter(Boolean).length !== this.attachedFiles.length
        ) {
          return;
        }
        const cleanedFilePreviews = this.filePreviews
          .filter(Boolean)
          .map((preview) =>
            preview.replace(/^data:image\/[a-zA-Z]+;base64,/, "")
          );
        const item = {
          fullName: this.fullName,
          phone: this.phone,
          address: this.address,
          city:this.city,
          email: this.email,
          subject: this.subject,
          message: this.message,
          consent: this.consent,
          files: cleanedFilePreviews
        }
        this.$store.dispatch(actionTypesAppeal.postAppeal, item)
            .then((data) => {
              if (data && data.status === "SUCCESS") {
                this.$emit("success");
                this.$emit("close");
              }
            })
            .catch((er) => {
              console.log("Ошибка", er);
            });

      },
    },
    mounted() {
      this.resizeMessageTextarea();
    },
  };
</script>
